var _style, _linearGradient, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremierBoostIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "premier-boost-icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 64 55",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 64 55"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".premier-boost-icon_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.premier-boost-icon_svg__st6{fill:#020203}.premier-boost-icon_svg__st7{fill:#e9eaeb}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "premier-boost-icon_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -388.52,
    y1: -270.104,
    x2: -387.813,
    y2: -269.397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#e2e2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#d5d4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#c0bfc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#a4a2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b6e6e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "premier-boost-icon_svg__Desktop-V5_00000064315882292028481080000017536584226661144472_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "premier-boost-icon_svg__PDI-Valuation_00000143606182330611349890000001221784314101355186_",
    transform: "translate(-740 -2065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "premier-boost-icon_svg__Group-21_00000089546220088888123380000009030819762585440131_",
    transform: "translate(740 2065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "premier-boost-icon_svg__Fill-1_00000023241917657998241890000002562445339201312426_",
    d: "M39.9 19.9c0 11-8.9 19.9-19.9 19.9S0 31 0 19.9C0 8.9 8.9 0 19.9 0s20 8.9 20 19.9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f9d8cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "premier-boost-icon_svg__Fill-3_00000135651620781015194350000015196772275155001482_",
    className: "premier-boost-icon_svg__st1",
    d: "M57 14H8c-1.1 0-2 .9-2 2v33h53V16c0-1.1-.9-2-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "premier-boost-icon_svg__Fill-5_00000067915708089851263550000001806245610403702451_",
    d: "M60 49h-2V16c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1v33H5V16c0-1.7 1.3-3 3-3h49c1.7 0 3 1.3 3 3v33z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "premier-boost-icon_svg__Fill-7_00000168088775918858587590000009807678677342297246_",
    className: "premier-boost-icon_svg__st1",
    d: "M63 49H39l-1 1H26l-1-1H1v2c0 1.7 1.4 3 3 3h56c1.7 0 3-1.3 3-3v-2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "premier-boost-icon_svg__Group-11_00000145016639390083962020000016041895169169590176_",
    transform: "translate(.01 48)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "premier-boost-icon_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 7,
    id: "premier-boost-icon_svg__mask-2_00000116942595202686126850000017173496776693647523_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#premier-boost-icon_svg__Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "premier-boost-icon_svg__path-1_00000147927203192842484780000015676708191574201501_",
    className: "premier-boost-icon_svg__st1",
    d: "M0 0h64v7H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "premier-boost-icon_svg__Fill-9_00000023962924111314376720000005573793834348429952_",
    d: "M2 2v1c0 1.1.9 2 2 2h56c1.1 0 2-.9 2-2V2H39.4l-1 1H25.6l-1-1H2zm58 5H4C1.8 7 0 5.2 0 3V0h25.4l1 1h11.2l1-1H64v3c0 2.2-1.8 4-4 4z",
    mask: "url(#premier-boost-icon_svg__mask-2_00000116942595202686126850000017173496776693647523_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#020203"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.7 31.7h5.9v14.1h-5.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st6",
    d: "M43.2 46.3h-7V31.2h7v15.1zm-6-1.1h4.9v-13h-4.9v13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st7",
    d: "M20.5 40.9h5.9v4.9h-5.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st6",
    d: "M27 46.3h-7v-5.9h7v5.9zm-6-1.1h4.9v-3.8H21v3.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st7",
    d: "M28.6 37.7h5.9v8.1h-5.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st6",
    d: "M35.1 46.3h-7v-9.2h7v9.2zm-6-1.1H34v-7h-4.9v7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st6",
    d: "M10.1 45.2h44.5v1.1H10.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e84b0f",
    d: "M43.2 18.7H37l1.5 1.6-8 8-4.2-4.2-8.8 8.7 3.1 3.1 5.3-5.3 4.2 4.2 11.5-11.5 1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "premier-boost-icon_svg__st6",
    d: "M20.6 36.7l-3.8-3.8 9.6-9.6 4.2 4.2 7.2-7.2-2.1-2.1h8v8l-2.1-2.1-11.5 11.4-4.2-4.2-5.3 5.4zm-2.3-3.8l2.3 2.3 5.4-5.4 4.2 4.2 11.4-11.4 1.1 1.1v-4.3h-4.3l1 1-8.9 8.6-4.2-4.2-8 8.1z"
  }))));
}
export default SvgPremierBoostIcon;